import {pluralize} from './number-helpers'

export const secondsToMs = (seconds: number) => seconds * 1000

export const minutesToMs = (minutes: number) => secondsToMs(minutes * 60)

export const hoursToMs = (hours: number) => minutesToMs(hours * 60)

export const daysToMs = (days: number) => hoursToMs(days * 24)

/**
 * Convert milliseconds to minutes. Rounds down.
 * @param ms number of milliseconds
 * @param precision number of decimal places to round down to
 */
export const msToMinutes = (ms: number, precision: number = 0) => {
  const minutes = ms / 1000 / 60
  return Math.floor(minutes * Math.pow(10, precision)) / Math.pow(10, precision)
}

/**
 * Convert milliseconds to hours. Rounds down.
 * @param ms number of milliseconds
 * @param precision number of decimal places to round down to
 */
export const msToHours = (ms: number, precision: number = 0) => {
  const days = ms / 1000 / 60 / 60
  return Math.floor(days * Math.pow(10, precision)) / Math.pow(10, precision)
}

/**
 * Convert milliseconds to days. Rounds down.
 * @param ms number of milliseconds
 * @param precision number of decimal places to round down to
 */
export const msToDays = (ms: number, precision: number = 0) => {
  const days = ms / 1000 / 60 / 60 / 24
  return Math.floor(days * Math.pow(10, precision)) / Math.pow(10, precision)
}

/** Convert number of minutes to a human-display string */
export const minutesDisplay = (minutes: number) => pluralize(minutes, 'minute')
/** Convert number of hours to a human-display string */
export const hoursDisplay = (hours: number) => pluralize(hours, 'hour')

/** Convert number of milliseconds to a human-display string in minutes */
export const msToMinutesDisplay = (ms: number) => {
  return minutesDisplay(msToMinutes(ms))
}
/** Convert number of milliseconds to a human-display string in hours */
export const msToHoursDisplay = (ms: number) => {
  return hoursDisplay(msToHours(ms))
}

/** Convert number of milliseconds to a human-display string in hours and minutes */
export const msToHoursMinutesDisplay = (ms: number) => {
  const hours = msToHours(ms)
  const remainder = ms - hoursToMs(hours)
  const minutes = msToMinutes(remainder)
  return `${hoursDisplay(hours)} ${minutesDisplay(minutes)}`
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/time-helpers.ts